import axios from "axios";
import qs from "qs";
import { Toast } from 'vant';

axios.defaults.withCredentials = false;

axios.create({
  timeout: 3 * 1000
});

/**
 * 请求拦截
 */
axios.interceptors.request.use(
  config => {
    config.baseURL =
      window.location.protocol === "http:"
        ? process.env.VUE_APP_BASE_API
        : process.env.VUE_APP_BASE_API_S;
    //process.env.NODE_ENV== 'development'?process.env.VUE_APP_BASE_API:'http://sd.shengbangtec.com'

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截
 */
axios.interceptors.response.use(
  response => {
    const { code, data, msg } = response.data;
    //下载文件
    if (response.config.isFile) {
      //文件名
      let filename = "unknown";
      if (response.config.filename) {
        filename = decodeURIComponent(response.config.filename);
      }
      const headers = response.headers;
      const contentType = headers["content-type"];
      console.log(contentType)
      // 文件处理
      if (contentType && !contentType.includes("application/json")) {
        // 需要下载的接口
        const link = document.createElement("a");
        if (response.config.fileneedback) {
          return {
            file: new Blob([response.data], { type: contentType }),
            filename
          };
        }
        link.download = filename;
        //文件数据
        const blob = new Blob([response.data], { type: contentType });
        console.log(response.config)
        if (!response.config.notDownload) {
          link.href = window.URL.createObjectURL(blob);
          // 下载
          link.click();
          return;
        } else {
          return window.URL.createObjectURL(blob)
        }
      }
    }
    if (code === 0) {
      return data;
    } else {
      Toast.fail(msg);
      return Promise.reject({ code, message: msg });
    }
    // return data
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          console.log("错误请求");
          break;
        case 401:
          console.log("未授权，请重新登录");
          break;
        case 404:
          console.log("请求错误,未找到该资源");
          break;
        case 408:
          console.log("请求超时");
          break;
        case 500:
          console.log("服务器端出错");
          break;
        default:
          console.log(`连接错误${err.response.status}`);
      }
    } else {
      console.log("连接到服务器失败");
    }
    return Promise.reject(err);
  }
);

export default axios;
